
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': '測試',
	'visualizationSlideoutTitle': '視覺化',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': '輸入數字',
	'maxValuePlaceholder': '輸入數字',
	'customRangeErrorMessage': '值必須為數字',
	'propFillColor': '填入顏色',
	'propBorderColor': '邊框顏色',
	'propColorPalette': '現行 color 選用區',
	'propColorPaletteChangeLabel': '變更 color 選用區',
	'propNewColorPaletteLabel': '建立自訂 color 選用區',
	'propNewHeatPaletteLabel': '建立自訂熱圖選用區',
	'propDonutRadius': '環圈圖半徑',
	'showTitleLabel': '顯示標題',
	'titleTypeLabel': '標題類型',
	'smartTitleLabel': '智慧型標題',
	'customTitleLabel': '自訂標題',
	'noTitleLabel': '沒有標題',
	'propHeatScalePalette': '現行熱圖選用區',
	'propHeatPaletteChangeLabel': '變更熱圖選用區',
	'propMaintainAxisScales': '維護軸刻度',
	'propLineAndSymbolColor': '線條和符號顏色',
	'propLineAndSymbolPalette': '線條和符號 color 選用區',
	'propElementColor': '元素顏色',
	'propColumnColor': '直欄顏色',
	'propColumnPalette': '直欄 color 選用區',
	'propColumnHeatPalette': '直欄熱圖選用區',
	'propBarColor': '條欄顏色',
	'propGoalColor': '目標顏色',
	'propToColor': '目標顏色',
	'propFromColor': '起始顏色',
	'propNumberValidationErrorMessageId': '輸入數字',
	'fontSizeAuto': '自動',
	'propAutoBinCount': '群組數',
	'propAutoBinToggle': '自動分組',
	'tabName_general': '一般',
	'tabName_visDetails': '詳細資料',
	'tabName_animation': '動畫',
	'tabName_mediaDetails': '媒體詳細資料',
	'tabName_webDetails': '網頁詳細資料',
	'tabName_imageDetails': '映像檔詳細資料',
	'tabName_visualization': '視覺化',
	'tabName_text': '文字',
	'sectionName_colorsAndThemes': '顏色及佈景主題',
	'sectionName_appearance': '外觀',
	'sectionName_general': '一般',
	'sectionName_colorPalette': '顏色',
	'sectionName_axis': '軸',
	'sectionName_axis_label': '軸',
	'sectionName_legend': '圖註',
	'sectionName_chart': '圖表',
	'sectionName_regionLayer': '區域層',
	'sectionName_pointLayer': '點層',
	'sectionName_latLongLayer': '緯度/經度層',
	'sectionName_pathLayer': '路徑層',
	'sectionName_xAxis': 'X 軸',
	'sectionName_yAxis': 'Y 軸',
	'sectionName_xAxis_title': 'X 軸標題',
	'sectionName_yAxis_title': 'Y 軸標題',
	'sectionName_xAxis_label': 'X 軸標籤',
	'sectionName_yAxis_label': 'Y 軸標籤',
	'sectionName_column_yAxis': '直欄 Y 軸',
	'sectionName_column_yAxis_label': '直欄 Y 軸標籤',
	'sectionName_column_yAxis_title': '直欄 Y 軸標題',
	'sectionName_line_yAxis': '線條 Y 軸',
	'sectionName_line_yAxis_label': '線條 Y 軸標籤',
	'sectionName_line_yAxis_title': '線條 Y 軸標題',
	'sectionName_title': '標題',
	'sectionName_dataValueLabels': '資料值標籤',
	'sectionName_style': '樣式',
	'propTransparencyDescription': '將物件設為更透明或更不透明。鍵入一個介於 0 與 100 之間的值',
	'smart_annotation_unauthorized': '註釋：未獲授權的存取',
	'smart_annotation_method': '註釋：不允許方法',
	'smart_annotation_media': '註釋：不允許媒體類型',
	'smart_annotation_input': '註釋：輸入無效',
	'smart_annotation_internal': '註釋：內部系統錯誤',
	'smart_annotation_generic_error': '註釋：服務錯誤',
	'smart_annotation_dialog_title': '見解',
	'smart_annotation_Show_Insights': '顯示見解',
	'smart_annotation_Relationship': '關係為',
	'forecast_enter_number': '輸入數字，介於',
	'and': ' 和 ',
	'smart_errors': '註釋錯誤：',
	'smart_warnings': '註釋警告：',
	'smart_annotation_insight_icon_title': '見解',
	'smart_annotations_toggle_on': '切換開啟見解',
	'smart_annotations_toggle_off': '切換關閉見解',
	'smart_annotation_toggle_on': '切換為開啟',
	'smart_annotation_toggle_off': '切換為關閉',
	'smart_annotation_insight_unavailable': '見解目前無法使用',
	'smart_annotation_insight_topBottom_percent_unsupported': '套用最高或最低百分比過濾器時無法使用見解',
	'smart_annotation_forecast_topBottom_percent_unsupported': '套用最高或最低百分比過濾器時無法使用預測',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': '套用最高或最低過濾器且欄位中有多個直欄時，無法使用洞察',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': '套用最高或最低過濾器且欄位中有多個直欄時，無法使用預測',
	'forecast_title': '預測',
	'forecast_show': '顯示預測',
	'forecast_toggle_on': '切換預測開啟',
	'forecast_toggle_off': '切換預測關閉',
	'statDetailsPerspectiveTitle': '分析',
	'emptyStatDetailsPanel': '現行視覺化沒有其他可用的分析。',
	'predict_errors': '分析錯誤',
	'predict_warnings': '分析警告',
	'fpd_invalid_data_source': '此資料來源沒有相關聯的智慧圖記模組',
	'fpd_network_issue': '對此資料來源執行分析時發生問題',
	'fpd_data_source_category': '遺漏智慧圖記模組',
	'fpd_response_errors': '建議的動因錯誤',
	'fpd_response_warnings': '建議的動因警告',
	'catalyst_service_bad_request': '要求錯誤',
	'catalyst_service_unkown_Id': '發現不明要求 ID',
	'catalyst_service_internal_server_error': '內部伺服器錯誤',
	'catalyst_service_generic_error': 'Catalyst 服務錯誤',
	'catalyst_service_error': '此服務目前無法使用',
	'propLegendPosition': '圖註位置',
	'propLeft': '左',
	'propRight': '右',
	'propTop': '上',
	'propBottom': '下',
	'propNone': '無',
	'propLegendDisplay': '顯示圖註',
	'targetThicknessPlaceHolder': '%{min} 到 %{max}',
	'targetThicknessErrorMsg': '輸入一個介於 %{min} 到 %{max} 之間的整數。',
	'possibleKeyDriver_DialogDriversLabelBegin': '動因（',
	'possibleKeyDriver_DialogDriversLabelEnd': '已選取）',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': '重設為預設值',
	'possibelKeyDriver_AddNewDrivers': '新增更多動因',
	'possibleKeyDrivers_NonRecommended_Placeholder': '搜尋以新增更多動因',
	'possibleKeyDrivers_MaxPossibleReached': '取消選取部分動因以新增或選取其他動因',
	'possibleKeyDrivers_Recommended': '建議',
	'visRecommendedTypes': '建議視覺化類型',
	'visRecommender_smartsfailure': '視覺化建議目前無法使用',
	'visMore': '其他...',
	'visMoreTooltip': '更多視覺化',
	'visOtherTypes': '其他視覺化類型',
	'visChange': '變更視覺化',
	'automaticTypeCaption': '自動',
	'propVisType': '視覺化類型',
	'dlg_loading': '載入中...',
	'snippetListChartCaption': 'Snippet 清單',
	'convoClusterChartCaption': '交談叢集',
	'areaChartCaption': '區域圖',
	'barChartCaption': '長條圖',
	'columnChartCaption': '直條圖',
	'stackedbarChartCaption': '堆疊長條圖',
	'stackedcolumnChartCaption': '堆疊直欄',
	'bubbleChartCaption': '泡泡圖',
	'marimekkoChartCaption': 'Marimekko 圖',
	'cometChartCaption': '動因分析',
	'scatterChartCaption': '散佈圖',
	'lineChartCaption': '折線圖',
	'pointChartCaption': '點',
	'heatChartCaption': '熱圖',
	'bulletChartCaption': '重點式圖表',
	'waterfallChartCaption': '瀑布圖',
	'radarChartCaption': '雷達圖',
	'boxplotChartCaption': '箱形圖',
	'pieChartCaption': '圓餅圖',
	'mapChartCaption': '地圖',
	'radialBarChartCaption': '放射狀圖',
	'compositeChartCaption': '折線圖和直條圖',
	'wordCloudChartCaption': '文字雲',
	'networkChartCaption': '網路',
	'relationshipNetworkChartCaption': '關係網路',
	'treemapChartCaption': '樹狀結構圖',
	'packedBubbleChartCaption': '壓縮泡泡圖',
	'hierarcicalPackedBubbleChartCaption': '階層泡泡圖',
	'spiralChartCaption': '螺旋圖',
	'decisionTreeChartCaption': '決策樹狀結構',
	'legacyMapChartCaption': '舊地圖',
	'sunburstChartCaption': '放射環狀圖',
	'visUsageComparison': '比較',
	'visUsageRelationships': '關係',
	'visUsageTrend': '趨勢',
	'visUsagePartsToWhole': '部分至整體',
	'visUsageGeospatial': '地理空間',
	'visUsageAdvanced': '進階分析',
	'visUsageTablesAndSummary': '表格及摘要',
	'visUsageSocialInsights': '社交見解',
	'visUsageOther': '其他',
	'autoBinActionText': '自動群組',
	'filterAutobinActionText': '過濾組',
	'memberCalculationActionText': '成員計算',
	'toolbarActionCalculation': '建立計算',
	'toolbarActionEditCalculation': '編輯計算',
	'topBottomRankLabel': '等級 (%{label})',
	'toolbarDeleteFilterActionText': '移除過濾器',
	'toolbarActionTopKeyDrivers': '顯示動因',
	'toolbarActionCustomGroup': '自訂群組',
	'canNotCreateCustomGroup': '您無法建立此自訂群組。',
	'aria_label_datatable': '資料表',
	'summaryCaption': '摘要',
	'MeasuresCaption': '測量',
	'MeasuresGroupCaption': '測量群組 (%{count})',
	'ValuesCaption': '值',
	'turnInsightsOn': '開啟見解',
	'turnInsightsOff': '關閉見解',
	'decisionRules': '規則',
	'decisionTree': '樹狀結構圖',
	'decisionSunburst': '樹狀結構放射環狀圖',
	'switchToDecisionRules': '切換至決策規則',
	'switchToDecisionTree': '切換至決策樹狀結構',
	'data_group_less_then': '小於 %{rangeTo}',
	'data_group_to': '%{rangeFrom} 到 < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} 及上述',
	'nullValueContent': '（沒有值）',
	'sum': '總和',
	'count': '計數',
	'countdistinct': '相異計數',
	'avg': '平均值',
	'min': '最小值',
	'max': '最大值',
	'automatic': '自訂',
	'variance': '變異數',
	'stddev': '標準差',
	'median': '中位數',
	'calculated': '計算',
	'none': '無',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': '提示值',
	'inputLabelPrompt': '值',
	'inputPlaceholderPrompt': '輸入值',
	'inputInvalidText': '%{dataType} 類型的無效輸入',
	'unSupportedPrompt': '不受支援的提示',
	'missingDataSource': '找不到正確的資料來源。',
	'unSupportedPromptType': '目前不支援此提示實務範例。',
	'preAggregateLabel': '從資料來源套用提示值',
	'postAggregateLabel': '在報告中套用提示值',
	'preAggregateText': '此範圍會使用資料來源中的值，而不會使用儀表板中所顯示的值。',
	'defaultAggregation_count': '計數',
	'defaultAggregation_countdistinct': '相異計數',
	'defaultAggregation_max': '最大值',
	'defaultAggregation_min': '最小值',
	'defaultAggregation_avg': '平均值',
	'defaultAggregation_sum': '總和',
	'defaultAggregation_auto': '自動 (%{aggregationType})',
	'keydriver_average': '整體平均值',
	'keydriver_up_down': '對目標有較大影響力的高或低平均值強調顯示群組。對目標有最大影響力的非常高或非常低平均值群組。',
	'keydriver_different': '其配送與整體配送明顯不同的強調顯示群組。這些群組對目標有較大影響力。',
	'topOperator': '上',
	'bottomOperator': '下',
	'topBottomFact': '%{operator} %{value}%{percent} 個（依 %{columnLabel}）',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': '刪除最前或最後計數',
	'deleteTopBottomPercent': '刪除最前或最後百分比',
	'topBottomTitle': '僅此物件',
	'deleteTopBottom': '刪除最前或最後計數',
	'editTopBottom': '編輯最前或最後計數',
	'editTopBottomCount': '編輯最前或最後計數',
	'editTopBottomPercent': '編輯最前或最後百分比',
	'ariaDeleteTopBottomCountLabel': '按 DELETE 鍵來刪除最前或最後計數。',
	'ariaDeleteTopBottomPercentLabel': '按 DELETE 鍵來刪除最前或最後百分比。',
	'ariaEditTopBottomCountLabel': '按 ENTER 鍵來編輯最前或最後計數。',
	'ariaEditTopBottomPercentLabel': '按 ENTER 鍵來編輯最前或最後百分比。',
	'ariaDeleteDrillStateLabel': '按 ENTER 鍵來編輯最前或最後計數。',
	'drillUpStateTitle': '向上逐層分析',
	'drillDownStateTitle': '向下逐層分析',
	'ariaEditTopBottomLabel': '按 ENTER 鍵來編輯最前或最後計數。',
	'ariaDeleteTopBottomLabel': '按 DELETE 鍵來刪除最前或最後計數。',
	'allKeyDriversLabel': '自動（所有動因）',
	'filter_drag_and_drop_single_dock': '將資料拖放至此來進行過濾。',
	'filter_drag_and_drop_all_tabs': '將資料拖放至此來過濾所有標籤。',
	'filter_drag_and_drop_current_tab': '將資料拖放至此來過濾這個標籤。',
	'filter_empty_consume_mode': '未套用任何過濾器。',
	'filterClearAllItems': '清除所有過濾器',
	'filterDeleteAllItems': '刪除所有過濾器',
	'filterDockChevronLeft': '捲動瀏覽資料',
	'filterDockChevronRight': '捲動瀏覽資料',
	'filterIconLabel_Single': '過濾器',
	'filterIconLabel_Global': '所有標籤',
	'filterIconLabel_Tab': '此標籤',
	'filterIconTooltip_Single': '過濾器',
	'filterIconTooltip_Global': '所有標籤的過濾器',
	'filterIconTooltip_Tab': '此標籤的過濾器',
	'filterDropZoneTooltip_Single': '過濾放下區域',
	'filterDropZoneTooltip_Global': '所有標籤的過濾放下區域',
	'filterDropZoneTooltip_Tab': '此標籤的過濾放下區域',
	'filterOverflowMenu': '其他',
	'expand': '展開',
	'collapse': '收合',
	'filterDockItemNameAriaLabel': '請按 Enter 鍵以啟動過濾器對話框，然後再定義此過濾器。',
	'filterItemCanvasMove': '新增至畫布',
	'filterItemDelete': '刪除過濾器',
	'filterInvertRange': '全部，除了：%{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': '不在 %{from} 之後',
	'filter_date_after': '在 %{from} 之後',
	'filter_date_before_except': '不在 %{to} 之前',
	'filter_date_before': '在 %{to} 之前',
	'filter_date_between_except': '未介於 %{from}-%{to} 之間',
	'filter_date_between': '介於 %{from}-%{to} 之間',
	'filterValueSeparator': ',',
	'filterAll': '全部',
	'filter': '過濾',
	'filterExcept': '除了 %{values}',
	'filterDockToolbarButtonLabel': '過濾平台',
	'navigateTitle': '導覽至',
	'navigateSelectColumn': '選取直欄',
	'navigateSelectPath': '選取導覽路徑',
	'current_nav_group': '現行導覽群組為 %{navigation_group_name}',
	'next': '下一步',
	'previous': '上一步',
	'multiselectMsg': '已選取 %{count} 個',
	'errMsgFilterItemMissingTitle': '無法載入過濾器值` %{itemName}，因為這些值無法與此資料集一起使用',
	'errMsgFilterItemGenericTitle': '無法載入過濾器值',
	'textFilterItemsNotFound': '無法使用項目。',
	'nullValueLabel': '（空白）',
	'filterConditionLabel': '過濾條件',
	'filter_includesAll': '併入全部',
	'filter_allMembersOfSet': '設定的全部成員',
	'modelFilter': '過濾',
	'filtersTitle': '過濾器內容',
	'search': '搜尋',
	'clearTextFilterValue': '清除',
	'invertFilterSelection': '反轉',
	'modellingLoading': '載入中...',
	'searchAll': '尋找所有直欄',
	'toolbarActionPossibleKeyDrivers': '編輯範圍',
	'toolbarActionPossibleKeyDriversSubTitle': '從左側拖曳要在動因分析圖表中考量的項目。',
	'toolbarActionSort': '排序',
	'toolbarActionSortAscending': '遞增',
	'toolbarActionSortDescending': '遞減',
	'toolbarActionSortAuto': '自動 (%{sortOrder})',
	'toolbarActionSortCustom': '自訂',
	'toolbarActionFormat': '格式資料',
	'toolbarActionFormatText': '格式資料（文字）',
	'toolbarActionFormatAbbreviation': '縮寫',
	'toolbarActionFormatNone': '自動',
	'toolbarActionFilter': '過濾',
	'toolbarActionTopBottom': '最前或最後',
	'toolbarActionRmvShape': '移除形狀',
	'toolbarActionToggleShapeDrop': '資訊圖表形狀',
	'toolbarActionToggleShapeDropTitle': '建立資訊圖表',
	'toolbarActionToggleShapeDropText': '將形狀拖曳至此欄位以建立資訊圖表。',
	'toolbarActionAggregationType': '彙總',
	'toolbarDeleteActionText': '移除直欄',
	'toolbarTextActionText': '樣式文字',
	'toolbarActionFilterLocalKeepSelected': '保留',
	'toolbarActionFilterLocalExcludeSelected': '排除',
	'toolbarActionFilterAllKeepSelected': '過濾',
	'toolbarActionSimpleCalculation': '簡式計算',
	'toolbarActionDrillBack': '返回',
	'toolbarActionDrillUp': '向上逐層分析',
	'toolbarActionDrillDown': '向下逐層分析',
	'toolbarActionJumpTo': '逐層分析',
	'toolbarActionNavigate': '導覽',
	'toolbarActionCreateFilterGroup': '建立新連線',
	'toolbarActionDisconnectFilterGroup': '斷開所有鏈結',
	'toolbarActionLinkFilterGroup': '新增至現有的連線',
	'toolbarActionLassoSelect': '選取工具',
	'toolbarActionRefreshDeveloperWidget': '重新整理',
	'textFontFamilySubClassHairline': '髮絲',
	'textFontFamilySubClassThin': '特細',
	'textFontFamilySubClassThinItalic': '特細斜體',
	'textFontFamilySubClassExtraLight': '非常細',
	'textFontFamilySubClassExtraLightItalic': '非常細斜體',
	'textFontFamilySubClassLight': '明亮',
	'textFontFamilySubClassLightItalic': '細斜體',
	'textFontFamilySubClassRegular': '標準',
	'textFontFamilySubClassRegularItalic': '標準斜體',
	'textFontFamilySubClassItalic': '斜體',
	'textFontFamilySubClassMedium': '中',
	'textFontFamilySubClassMediumItalic': '中等斜體',
	'textFontFamilySubClassHeavy': '特粗',
	'textFontFamilySubClassHeavyItalic': '特粗斜體',
	'textFontFamilySubClassDemiBold': '半粗體',
	'textFontFamilySubClassDemiBoldItalic': '半粗斜體',
	'textFontFamilySubClassBold': '粗體',
	'textFontFamilySubClassBoldItalic': '粗斜體',
	'textFontFamilySubClassExtraBold': '非常粗',
	'textFontFamilySubClassExtraBoldItalic': '非常粗斜體',
	'textFontFamilySubClassBlack': '黑色',
	'textFontFamilySubClassBlackItalic': '特黑斜體',
	'textFontFamilySubClassStencil': '模板字體',
	'dlg_ascending': '遞增',
	'dlg_descending': '遞減',
	'dlg_custom': '自訂',
	'dlg_none': '無',
	'dlg_hierarchy': '階層',
	'dlg_namedSet': '具名集',
	'dlg_rank': '等級',
	'visualizationLabel': '視覺化',
	'chartLabel': '%{chartName} 圖表',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': '按 F12 在小組件內進行導覽',
	'f10KeyDescription': '按 F10 以啟動小組件焦點視圖',
	'playButtonLabel': '播放',
	'dataPlayerValueListLabel': '資料播放程式值',
	'localFilterTitle': '僅此物件',
	'globalFilterTitle': '所有物件',
	'deleteFilter': '刪除過濾器',
	'editFilter': '編輯過濾器',
	'ariaEditFilterLabel': '按 ENTER 鍵來編輯過濾器。',
	'ariaDeleteFilterLabel': '按 DELETE 鍵來刪除過濾器。',
	'measureFilterBetween': '介於 %{lowerBound} 到 %{upperBound} 之間',
	'measureFilterNotBetween': '未介於 %{lowerBound} 到 %{upperBound} 之間',
	'dimFilterIn': '併入項目：%{in}',
	'dimFilterNotIn': '排除項目：%{out}',
	'gtFilter': '在 %{lowerBound} 之後',
	'ltFilter': '在 %{upperBound} 之前',
	'ariaEditPrompt': '按 ENTER 鍵以變更提示值',
	'dataPointFilterTitle': '資料點',
	'dataPointFilterIncludeSummary': '已包含 %{valueCount} 個資料點',
	'dataPointFilterExcludeSummary': '已排除 %{valueCount} 個資料點',
	'widgetFiltersLabel': '小組件過濾器',
	'coachMarkTitleSpiralTarget': '編輯範圍',
	'coachMarkContentSpiralTarget': '您可以在此處存取及修改目標動因選項。',
	'srILVTreeLabel': '清單',
	'geomapUnrecognizedLocations': '無法辨識的位置：',
	'geomapAmbiguousLocations': '不明確區域：',
	'visualizationNotifications': '視覺化通知：',
	'dataNotifications': '資料通知：',
	'autobinSuggestion': '開啟自動分組',
	'LIVE_empty_visualization_hint_title': '建置您的視覺化',
	'LIVE_empty_visualization_hint_description': '將資料拖放到這裡或欄位。',
	'LIVE_slots_required_field_description': '%{asterisk} 指出必要欄位',
	'LIVE_slots_drag_and_drop_description': '將資料拖放至上方的欄位來建置及過濾視覺化。',
	'dwErrorLoadingAvailableVisualizations': '我們無法載入可用的視覺化定義。',
	'moreDataIndicator': '在 %{threshold} 項目上，資料已被裁切。請套用過濾器以精簡顯示。',
	'nonCtxTopBottomInvalid': '交叉資料表不支援定義不含環境定義的最前或最後規則。它會從此交叉資料表視圖移除。對 %{columnName} 的環境定義中一個以上的種類重新定義規則。',
	'dwErrorLoadingVisualizationNotFound': '我們無法載入物件，因為它遺漏視覺化定義。',
	'dwErrorLoadingVisualizationListNotFound': '我們無法載入視覺化。',
	'dwErrorRunningQuery': '無法從資料集 %{datasetName} 中擷取資料。',
	'dwErrorGeoData': '顯示對映中的地理資料時發生困難。請選擇另一種視覺化類型。',
	'dwPromptSignonCancelWarning': '此視覺化的資料無法使用。請提供正確認證。',
	'dwErrorMissingDataset': '我們無法載入視覺化，因為無法使用其關聯的資料集 "%{datasetName}"。',
	'dwErrorRenderingVisualization': '我們無法載入此視覺化。',
	'dwErrorVisualizationTooSmall': '視覺化太小，無法顯示其所含的資料。請設定較大的視覺化，或限制其所含的資料。',
	'errorSourceNotFound': '我們無法載入視覺化，因為無法使用其關聯的來源 "%{sourceName}"。',
	'errorActionNotSupported': '資料來源 "%{sourceName}" 不支援此動作。',
	'errorMeasureNotSupportedOnMultiEdges': '視覺化對多個邊緣有不再受到支援的測量。請將測量只放置在某個邊緣。',
	'errorExceedAllowableValue': '預估的儲存格數超出 100000 的容許值。請對預估集進行過濾以減少儲存格數。',
	'propScaleLabel': '圖示數量',
	'propScaleDescription': '選取圖示數量',
	'propScaleFew': '低',
	'propScaleDefault': '預設',
	'propScaleMany': '高',
	'lastRefresh': '前次重新整理時間：%{timeInterval} 前',
	'widgetTimer': '小組件計時器',
	'datasetItemsUnavailable': '此視覺化中所使用的某些資料集項目無法使用。',
	'datasetItemUnavailable': '此資料集項目無法使用',
	'retry': '重試',
	'widgetConditionalFormatLabel': '切換條件式格式控制項',
	'widgetConditionalFormatTitle': '編輯條件式格式顏色',
	'crosstabName': '交叉資料表',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/A',
	'summaryLabel': '%{label} 的值為 %{value}',
	'infographicLabel': '%{label} 的值為 %{value}',
	'warning': '警告',
	'swapRowsAndColumns': '交換列和欄',
	'hideSummariesLabel': '隱藏摘要',
	'showSummariesLabel': '顯示摘要',
	'hideRowColumn': '隱藏',
	'showAllRowColumn': '全部顯示',
	'dataAssetPropertiesLabel': '視覺化內容',
	'evAdd': '新增直欄',
	'evCollapse': '收合',
	'evColumns': '直欄',
	'evLocalFilters': '本端過濾器',
	'evExpand': '展開',
	'evFilterTooltip': '過濾',
	'missingColumn': '遺漏：%{columnLabel}',
	'missingFiltering': '直欄中遺漏過濾器：',
	'missingDataItem': '小組件中找不到參照資料項目 "%{dataItemId}"。',
	'heatByLabel': '熱度依據',
	'toolbarChangeVisualization': '變更視覺化',
	'modellingRelatedTablesNoneFound': '找不到相關的表格',
	'processing': '處理中...',
	'errorCellWarning': '無法計算部分摘要值。',
	'aggregateTypeToggler': '顯示聚集類型',
	'maxColumnsExceeded': '已超出最大直欄數。已捨棄 %{columns}。',
	'unboundColumns': '無法使用下列直欄：%{columns}。',
	'unboundColumn': '無法使用下列直欄：%{columns}。',
	'recommendRequestFailed': '建議要求失敗。請與管理者聯絡。',
	'visualizationDoesNotSupportOLAP': '我們無法建立基於 OLAP 資料來源的這個視覺化。請使用另一個支援的資料來源。',
	'showDataBehindVizLabel': '顯示資料',
	'showDataBehindVizNotSupportedLabel': '此視覺化類型不支援顯示資料',
	'exploreData': '探索 ...',
	'newExplore': '新建探索',
	'thumbnails_error_fetching': '提取縮圖時發生錯誤',
	'loadedThumbnailImage': '已載入 %{visType} 視覺化縮圖影像',
	'autobinAxisLabel': '群組',
	'recommended_visualizations': '建議的視覺化',
	'all_visualizations': '所有視覺化',
	'edit': '編輯',
	'selectTargetDialogTitle': '選取重複逐層分析目標',
	'noTargetInCM': '找不到逐層分析的目標',
	'errorDrillDefinition': '在新增或編輯重複逐層分析定義時出現一些錯誤。',
	'errorDrillToTarget': '逐層分析至 "%{targetName}" 時發生錯誤',
	'drillThroughMappingViewLabel': '將儀表板中的直欄指派給目標報告的提示',
	'drillthroughScopeRadioLabel': '套用此定義的目標：',
	'drillthroughScopeRadioOptionVisualization': '僅此視覺化',
	'drillthroughScopeRadioOptionConnection': '使用相同資料來源的相同連線中的視覺化',
	'drillthroughScopeRadioOptionDashboard': '使用相同資料來源的 %{perspective} 上的全部視覺化',
	'drillThroughParametersColumnTitle': '"%{targetName}" 提示：',
	'drillThroughMetadataColumnTitle': '"%{boardName}" 資料直欄：',
	'drillThroughDefinitionNoParameter': '重複逐層分析目標沒有提示。',
	'drillThroughDefinitionErrorQueryingReport': '請更正目標報告的問題，然後再次嘗試建立重複逐層分析定義。',
	'drillThroughDefinitionErrorDlgTitle': '發生一些錯誤',
	'dlg_back': '回上頁',
	'dlg_close': '關閉',
	'dlg_ok': '確定',
	'dlg_cancel': '取消',
	'dlg_apply': '套用',
	'dlg_create': '建立',
	'dlg_done': '完成',
	'drillthrough_unsaveMsg': '繼續執行而不儲存 "%{name}" 嗎？',
	'drillthrough_jumpTo': '重複逐層分析定義：%{name}',
	'drillthrough_jumpToLabel': '逐層分析',
	'drillthrough_manage': '管理...',
	'drillthrough_addNewTarget': '新增重複逐層分析定義',
	'drillthrough_manageJumpPaths': '管理重複逐層分析定義',
	'drillthrough_manageJumpPaths_edit': '編輯 "%{name}"',
	'drillthrough_manageJumpPaths_delete': '刪除 "%{name}"',
	'drillthrough_manageAddAnotherTarget': '新增另一個重複逐層分析定義',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': '確認刪除',
	'drillthrough_manageConfirmeDeleteDrillTarget': '您確定要刪除重複逐層分析 "%{name}" 嗎？',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': '重複逐層分析名稱',
	'drillthrough_definitionMessage': '重複逐層分析 "%{name}" 已存在。請提供不同的名稱',
	'drillthrough_jumpToTarget_notFound': '找不到重複逐層分析 "%{name}" 的目標',
	'drillThroughDefinitionNoParameterSubTitle': '不會將任何環境定義傳遞給目標報告。',
	'drillthrough_titleLabel': '名稱',
	'drillthrough_create_dialogTitle': '建立重複逐層分析定義',
	'drillthrough_edit_dialogTitle': '編輯重複逐層分析定義',
	'drillthrough_subTitle': '來源中視覺化的環境定義是用來過濾目標 %{perspective}。',
	'drillthrough_selectColumn': '選取直欄',
	'noPrompt': '無提示',
	'promptDialog': '%{promptType} 提示對話框',
	'formatAutoDescription': '自動會指定從您的資料來源或視覺化中繼承的格式。',
	'formatDefaultDescription': '預設值會指定從系統中繼承的格式',
	'createCustomGroupAction': '建立資料群組',
	'removeCustomGroupAction': '移除資料群組',
	'editCustomGroupAction': '編輯資料群組',
	'renameCustomGroupAction': '重新命名資料群組',
	'createCustomGroupErrorToast': '您的資料群組無法建立。',
	'removeCustomGroupErrorToast': '您的資料群組無法移除。',
	'editCustomGroupErrorToast': '您的資料群組無法編輯。',
	'renameCustomGroupErrorToast': '您的資料群組無法重新命名。',
	'customGroupLabel': '建立資料群組',
	'ungroupCustomGroupLabel': '取消群組',
	'renameCustomGroupLabel': '重新命名',
	'createCustomGroupLabel': '建立',
	'customGroupingLabel': '%{columnLabel}（群組）',
	'createCustomSort': '建立自訂排序',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': '選取可用項目，再將它們重新排序以建立自訂排序。',
	'availableItems': '可用項目',
	'selectAll': '全選',
	'customSortOrder': '自訂排序',
	'selectAvailableItemsDesc': '選取可用項目，並在此將它們重新排序。',
	'moveToTop': '移至頂端',
	'clear': '清除',
	'sortRemainingItemsBy': '剩餘項目的排序方式',
	'removeAll': '全部移除',
	'resetTooltip': '會移除 %{customSortOrder} 清單中的所有項目。並且，%{sortRemainingItemsBy} 下拉清單將回復為預設值。',
	'manyItemsWarning': '選取多個項目可能會影響儀表板的效能。',
	'manyItemsSelected': '已選取一個以上的 %{maxItems} 項目，這種情況可能會影響儀表板的效能。',
	'somethingWentWrong': '喔，事情不太對勁。',
	'tryAgain': '重試',
	'customSortLabel': '自訂排序',
	'applyError': '無法套用 %{action}。',
	'searchReturnedNoResults': '嗯，您的搜尋沒有返回任何結果。',
	'extVisSystem': '系統',
	'extVisCustom': '自訂',
	'customVisTestVisualization': '測試視覺化',
	'extVisCustomVisPreview': '預覽',
	'extVisCustomPreviewWidgets': '開發人員小組件',
	'extVisCustomVVisualization': '視覺化',
	'extVisCustomVisuals': '自訂視覺化',
	'noPermissionToManage': '您沒有管理自訂視覺化的權限。',
	'extVisCustomUpdate': '更新',
	'extVisCustomDelete': '刪除',
	'extVisNoCustomVisuals': '無自訂視覺化',
	'extVisNoCustomVisualsMsg': '您的組織中目前沒有自訂視覺化',
	'extVisAddCustomVisual': '新增自訂視覺化',
	'extVisNoCustomVisualsAdminMsg': '目前沒有自訂視覺化。新增一個以開始使用',
	'extVisNoSDKConnection': '未對您的本端檔案建立任何連線',
	'extVisNoSDKPreviewMsg': '若要預覽您的視覺化，請建立一個連線。',
	'extVisMore': '其他',
	'extVisDeleteDialogTitle': '刪除自訂視覺化',
	'extVisDeleteDialogBody': '您確定要刪除此自訂視覺化嗎？其他儀表板及報告可能正在使用它。',
	'extVisDeleteConfirmation': '您的自訂視覺化已刪除。',
	'extVisDeleteError': '您的自訂視覺化無法刪除。%{msg}',
	'extVisCloseToast': '立即關閉',
	'extVisAdd': '您的自訂視覺化已順利新增。',
	'extVisAddError': '您的自訂視覺化無法新增。%{msg}',
	'extVisUpdate': '您的自訂視覺化已順利更新。',
	'extVisUpdateError': '您的自訂視覺化無法更新。%{msg}',
	'extVisAddProgress': '匯入 %{name}',
	'extVisUpdateProgress': '更新 %{name}',
	'extPermissionTitle': '受限存取權或已刪除自訂視覺化',
	'extPermissionBody': '無法檢視此自訂視覺化，因為它已刪除或具有受限存取權。',
	'customVizSaveWarning': '無法儲存您的自訂視覺化。它們尚未匯入。',
	'schematicTestCaption': '測試圖表',
	'schematicServiceRequestError': '示意圖服務錯誤',
	'extVisPreviewMessage': '這是預覽。視覺化尚未新增至產品。',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': '未定義',
	'kpiDefaultTargetLabel': '目標',
	'kpiNonNumericTarget': '目標值必須是數字。',
	'kpiManualTargetSlotFilled': '欄位中已套用的值',
	'kpiAutoValueSize': '自動',
	'kpiUnableDrawSparklineLabel': '無法繪製走勢圖',
	'kpiUnableDrawSparklineInfo': '走勢圖最少需要 2 個復原點。變更資料或調整過濾器以查看走勢圖。',
	'conditionalFormattingTextColor': '文字顏色',
	'suppression': '抑制',
	'suppressNone': '無',
	'suppressRowsAndColumns': '列和欄',
	'suppressRows': '列數',
	'suppressColumns': '直條圖',
	'enableSuppression': '啟用抑制',
	'disableSuppression': '停用抑制',
	'loadVisDefinitionError': '無法載入視覺化 %{id} 的定義',
	'emptyVisualization': '空白視覺化',
	'expandCollapse': '展開和收合',
	'expandBtnLabel': '展開',
	'collapseBtnLabel': '收合',
	'prop_sizeInputNonNumericValue': '值必須是數字。',
	'prop_sizeValueShouldBeHigher': '值必須大於 %{value}。',
	'fontPropLabel': '字型系列',
	'fontSizePropLabel': '字型大小',
	'sectionItemAxisTitle': '項目軸標題',
	'sectionItemAxisLabel': '項目軸標籤',
	'sectionValueAxisTitle': '值軸標題',
	'sectionValueAxisLabel': '值軸標籤',
	'styletext-widget.legend': '圖註',
	'styletext-itemAxis.ticks.labels': '軸標籤',
	'styletext-valueAxis.title': '軸標題',
	'styletext-itemAxis.title': '軸標題',
	'styletext-labels': '資料標籤',
	'styletext-valueAxis.line.title': '線條標題',
	'styletext-cellValue': '值',
	'styletext-values': '值',
	'styletext-rowHeading': '列標題',
	'styletext-columnHeading': '直欄標題',
	'fontFamily': '系列',
	'fontSize': '大小',
	'visExportFileName': '視覺化',
	'ds-missingDataSet': '找不到資料集。請確定已順利建立資料集。',
	'ds-missingDashboardId': '請先儲存儀表板，才能建立資料集。',
	'ds-unsupportedDataSourceType': '不支援 %{type} 資料來源類型。',
	'dataCache': '資料快取',
	'dataCache_on': '開啟',
	'dataCache_off': '無快取',
	'dataCache_auto': '自動',
	'queryOptimization': '查詢最佳化'
});
